import React from "react";
import { Col } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import ReactTooltip from "react-tooltip";
import { PostStyle } from "../../../../types/services/IPost";
import SegmentedToggle from "../../integrations/common/segmentedToggle";
import s from "./styles.scss";

interface Props {
  postType: PostStyle;
  colSize: number;
  disabled: boolean;
  onChange: (value: string) => void;
}

const MessageTypeSection: React.FC<Props> = ({
  postType,
  colSize,
  disabled,
  onChange,
}) => {
  const value = postType === "onlySms" ? "onlySms" : "onlyMms";

  return (
    <Col sm={colSize}>
      <SegmentedToggle
        title="Message type"
        value={value}
        options={[
          { value: "onlySms", label: "SMS" },
          { value: "onlyMms", label: "MMS" },
        ]}
        onChange={onChange}
        disabled={disabled}
        showInfo
        infoId="MessageType"
        compact
      />
      <ReactTooltip
        id="tpMessageType"
        type="info"
        place="top"
        effect="float"
      >
        SMS will send only a text message with a link to open the ViewSpark,
        while MMS will also add an extra image to the message.
      </ReactTooltip>
    </Col>
  );
};

export default withStyles(s)(MessageTypeSection);
